import { NFrefModel } from "model/api/gestao/venda/venda-completa-model"
import { Grid, Typography } from "@material-ui/core";
import { useStyles } from "../card-doc-referenciados-styles";
import classNames from "classnames";
import { TipoDocRefMock } from "data/mocks/tipo-doc-ref-mock";
import { useThemeQueries } from "views/theme";
import { EditarIcon } from "views/components/icons";

interface Props {
    model: NFrefModel
}

export const DocReferenciadoNFe = ({ model }: Props) => {
    const myClasses = useStyles()
    const valorReal = Object.entries(model).find(x => x[1])
    const getKey = Object.keys(model).filter(x => x === valorReal?.[0] || '')
    const { isMobile } = useThemeQueries()
    return (
        <>
            <Grid container spacing={1} justifyContent="space-between">
                <Grid item xs={11}>
                    <Grid item className={myClasses.content} >
                        <Typography color="primary" variant="body2">
                            Tipo de Documento
                        </Typography>
                        <Typography
                            className={classNames('celula-grid-value', myClasses.valores)}
                            color="textPrimary"
                            variant="body2"
                        >
                            {TipoDocRefMock.filter(x => x.Key === getKey[0])[0].Value}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography color="primary" variant="body2">
                            Número da Chave de Acesso
                        </Typography>
                        <Typography
                            className={classNames('celula-grid-value', myClasses.valores)}
                            color="textPrimary"
                            variant="body2"
                        >
                            {model.refNFe}
                        </Typography>
                    </Grid>
                </Grid>
                {isMobile &&
                        <Grid xs={1} item style={{display:'flex'}} alignItems="center" justifyContent="flex-end">
                            <EditarIcon tipo='BUTTON' />
                        </Grid>
                    }
            </Grid>
        </>
    )
}